/**
 * Tiny event channel that supports publishing data events and
 * subscribing to them with anonymous function listeners.
 */
class AppChannel {
  constructor() {
    this.events = {};
  }

  publish(event, ...args) {
    if (!this.events[event]) return;

    for (const subscriber of this.events[event]) {
      subscriber(...args);
    }
  }

  subscribe(event, subscriber) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(subscriber);
  }
}

export default AppChannel;
